import {
  Box,
  Button,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import GCAutocompleteCheckbox from "../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox";
import {
  CmpSelectField,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import MoreVertIcon from "@mui/icons-material";
import GCSupplierSearch from "../../Component/Common/ReuseableComponent/GCSupplierSearch";
import GCBrandSearch from "../../Component/Common/ReuseableComponent/GCBrandSearch";
import { exportToExcel } from "../../Utility/Utilitys";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";

const HeaderComponent = ({
  HeadObject,
  setHeadObject,
  fLocation_MultiSelect,
  fLocation,
  sWebStockReportData,
  sLocationData,
  sMainGroupData,
  sSubGroupData,
  fMainGroup,
  fMainGroup_MultiSelect,
  fSubGroup,
  fSubGroup_MultiSelect,
  fCategory,
  sCategoryData,
  fCategory_MultiSelect,
  fMainSupplier,
  fBrand,
  apiRef,
  onLoad,
  fSave,
  fClear,
  summaryRows,
}) => {
  console.log(sLocationData);
  const isMobile = useMediaQuery("(max-width:650px)");
  return (
    <Box p={2}>
      <Grid container spacing={2}>
        {/* ======================= ROW 1 ======================= */}
        {/* Location */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={3} sm={2} md={2}>
              <CmpTypographyField xcomponent="span" xText="Location" />
            </Grid>

            <Grid item xs={3} sm={1.2} md={2}>
              <CmpSelectField
                xtabIndex="01"
                xLabelText="sLocation"
                xValue={HeadObject.sLocation}
                xOnChange={fLocation}
                xName="sLocation"
                xData={sWebStockReportData}
                xDisable={true}
              />
            </Grid>

            <Grid item xs={6} sm={8.8} md={8}>
              <GCAutocompleteCheckbox
                xtabIndex="02"
                options={sLocationData ?? []}
                xDisabled={HeadObject?.sLocation?.toUpperCase() === "ALL"}
                xValue={HeadObject.sLocationArr}
                setValue={fLocation_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Main Group */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={3} sm={2} md={2}>
              <CmpTypographyField xcomponent="span" xText="Main Group" />
            </Grid>

            <Grid item xs={3} sm={1.2} md={2}>
              <CmpSelectField
                xtabIndex="03"
                xLabelText="sMainGroup"
                xValue={HeadObject.sMainGroup}
                xOnChange={fMainGroup}
                xName="sMainGroup"
                xData={sWebStockReportData}
              />
            </Grid>

            <Grid item xs={6} sm={8.8} md={8}>
              <GCAutocompleteCheckbox
                xtabIndex="04"
                options={sMainGroupData}
                xDisabled={HeadObject?.sMainGroup?.toUpperCase() === "ALL"}
                xValue={HeadObject.sMainGroupArr}
                setValue={fMainGroup_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* ======================= ROW 2 ======================= */}
        {/* Sub Group */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={3} sm={2} md={2}>
              <CmpTypographyField xcomponent="span" xText="Sub Group" />
            </Grid>

            <Grid item xs={3} sm={1.2} md={2}>
              <CmpSelectField
                xtabIndex="05"
                xLabelText="sSubGroup"
                xValue={HeadObject.sSubGroup}
                xOnChange={fSubGroup}
                xName="sSubGroup"
                xData={sWebStockReportData}
              />
            </Grid>

            <Grid item xs={6} sm={8.8} md={8}>
              <GCAutocompleteCheckbox
                xtabIndex="06"
                options={sSubGroupData}
                xDisabled={HeadObject?.sSubGroup?.toUpperCase() === "ALL"}
                xValue={HeadObject.sSubGroupArr}
                setValue={fSubGroup_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Category */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={3} sm={2} md={2}>
              <CmpTypographyField xcomponent="span" xText="Category" />
            </Grid>

            <Grid item xs={3} sm={1.2} md={2}>
              <CmpSelectField
                xtabIndex="07"
                xLabelText="sCategory"
                xValue={HeadObject.sCategory}
                xOnChange={fCategory}
                xName="sCategory"
                xData={sWebStockReportData}
              />
            </Grid>

            <Grid item xs={6} sm={8.8} md={8}>
              <GCAutocompleteCheckbox
                xtabIndex="08"
                options={sCategoryData}
                xDisabled={HeadObject?.sCategory?.toUpperCase() === "ALL"}
                xValue={HeadObject.sCategoryArr}
                setValue={fCategory_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* ======================= ROW 3 ======================= */}
        {/* Main Supplier */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={3} sm={2} md={2}>
              <CmpTypographyField xcomponent="span" xText="Main Supplier" />
            </Grid>

            <Grid item xs={3} sm={1.2} md={2}>
              <CmpSelectField
                xtabIndex="09"
                xLabelText="sMainSupplier"
                xValue={HeadObject.sMainSupplier}
                xOnChange={fMainSupplier}
                xName="sMainSupplier"
                xData={sWebStockReportData}
              />
            </Grid>

            <Grid item xs={6} sm={8.8} md={8}>
              <GCSupplierSearch
                xValue={HeadObject.sSupplierSearchValue}
                xOnChange={(e) =>
                  setHeadObject((obj) => ({
                    ...obj,
                    sSupplierSearchValue: e.target.value,
                  }))
                }
                xReadOnly={HeadObject?.sMainSupplier?.toUpperCase() === "ALL"}
                basketValue={HeadObject?.sMainSupplierArr}
                xListValue={HeadObject?.sMainSupplierArr
                  .map((x) => x.Name1)
                  .join(", ")}
                onApply={(selectedObjects) =>
                  setHeadObject((obj) => ({
                    ...obj,
                    sMainSupplierArr: selectedObjects,
                  }))
                }
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Brand */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={3} sm={2} md={2}>
              <CmpTypographyField xcomponent="span" xText="Brand" />
            </Grid>

            <Grid item xs={3} sm={1.2} md={2}>
              <CmpSelectField
                xtabIndex="11"
                xLabelText="sBrand"
                xValue={HeadObject.sBrand}
                xOnChange={fBrand}
                xName="sBrand"
                xData={sWebStockReportData}
              />
            </Grid>

            <Grid item xs={6} sm={8.8} md={8}>
              <GCBrandSearch
                xValue={HeadObject?.sBrandSearchValue}
                xOnChange={(e) =>
                  setHeadObject((obj) => ({
                    ...obj,
                    sBrandSearchValue: e.target.value,
                  }))
                }
                xReadOnly={HeadObject?.sBrand?.toUpperCase() === "ALL"}
                basketValue={HeadObject?.sBrandArr}
                xListValue={HeadObject?.sBrandArr
                  .map((x) => x.Name1)
                  .join(", ")}
                onApply={(selectedObjects) =>
                  setHeadObject((obj) => ({
                    ...obj,
                    sBrandArr: selectedObjects,
                  }))
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              sx={{
                display: "flex",
                alignItems: isMobile ? "center" : "flex-end",
                textAlign: isMobile ? "center" : "end",
                justifyContent: isMobile ? "center" : "flex-end",
              }}
            >
              <Stack
                direction={"row"}
                spacing={{ xs: 0.5, md: 1 }}
                flexWrap={"wrap"}
              >
                <Button variant="contained" size="small" onClick={onLoad}>
                  Load
                </Button>
                <Button variant="contained" size="small" onClick={fSave}>
                  Save
                </Button>
                <Button variant="contained" size="small" onClick={fClear}>
                  Clear
                </Button>
                <Tooltip title="Export CSV">
                  <IconButton
                    color="primary"
                    onClick={() =>
                      exportToExcel(summaryRows, "ItemMSP", "ItemMSP")
                    }
                    size="small"
                  >
                    <DownloadOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HeaderComponent;
